

import React, { memo, Fragment } from 'react';
import { Dropdown, DatePicker, Text } from '../../../ui-kit';
import EXPIRY_DATE_OPTIONS from '../constants/expiryDateOptions';

import '../styles/_expiration-dropdown.scss';








function ExpirationDropdown({
  isExpirationSet,
  onExpirationUpdate,
  toggleExpiration,
  expiryDate: linkExpiryDate
}) {
  const onStartDateChange = (date) => {
    const expiryDate = date.utc(true).toISOString();
    onExpirationUpdate({ expiryDate });
  };

  const optionIndex = isExpirationSet ? 1 : 0;

  return (
    <Fragment>
      <div className="link-expiration">
        <Text noMargin className="link-expiration__title">
          Link Expiry
        </Text>
        <Dropdown
          className="expiration-dropdown"
          onChange={toggleExpiration}
          options={EXPIRY_DATE_OPTIONS}
          defaultValue={EXPIRY_DATE_OPTIONS[0]}
          value={EXPIRY_DATE_OPTIONS[optionIndex]}
          labelProps={{ required: true }}
          fontSize={12}
          hideSeparators
          type="BUTTON" />

      </div>

      {isExpirationSet &&
      <DatePicker
        id="expiry-date"
        startLabel="Expiry Date"
        openDown
        startDate={linkExpiryDate}
        onSelectStartDate={onStartDateChange} />}


    </Fragment>);

}

export default memo(ExpirationDropdown);